// extracted by mini-css-extract-plugin
export default {"PdfLink":"styles__PdfLink__CCQtt","Link":"styles__Link__PWH3H","Text":"styles__Text__XUQGk"};